module.exports = __webpack_public_path__ + "static/media/Pikachu.c9a67078.png";